module.exports = __webpack_public_path__ + "media/images/vp/parallax.01.1-8ff331bc78cd8ddc1e714f9db2d8244c.png";